import { storage } from "../storage/port";
/**
 * Remembers that a user has been shown the "how credits work" intro.
 *
 * Keyed by uuid rather than stored as a single flag: on a shared device the
 * next person to log in is a different user with their own unspent bonus, and
 * they should get their own intro.
 */
const PREFIX = "creditsIntroSeen:";
const key = (uuid) => `${PREFIX}${uuid}`;
export const creditsIntroSeen = (uuid) => storage.get(key(uuid)) === "true";
export const markCreditsIntroSeen = (uuid) => storage.set(key(uuid), "true");
/**
 * Clears every user's flag on logout.
 *
 * By prefix rather than by uuid so this doesn't depend on being called before
 * the uuid itself is removed from localStorage.
 */
export const clearCreditsIntroSeen = () => {
    for (const key of storage.keys()) {
        if (key.startsWith(PREFIX))
            storage.remove(key);
    }
};
//# sourceMappingURL=creditsIntroSeen.js.map